import { Component, OnInit, ViewChild } from '@angular/core';
import { GridOptions } from 'ag-grid-community';
import * as moment from 'moment';
import { CeqTableComponent } from 'src/app/ceq/common/ceq-table/ceq-table.component';
import { DeleteChildRendered } from '../../../common/renders/delete-child-rendered';
import { EditChildRendered } from '../../../common/renders/edit-child-rendered';
import { SettingsService } from 'src/app/core/settings/settings.service';
import { CarrierService } from '../carrier.service';
import { UserLogin } from 'src/app/ceq/common/models/UserLogin.Model';
import { Ceve } from 'src/app/ceq/common/models/Ceve.Model';
import { GlobalFunctionsService } from 'src/app/ceq/common/functions/global-functions.service';

@Component({
  selector: 'app-carrier-list',
  templateUrl: './carrier-list.component.html',
  styleUrls: ['./carrier-list.component.scss']
})
export class CarrierListComponent implements OnInit {

  constructor(
    private globalFunctionService: GlobalFunctionsService,
    private settings: SettingsService,
    private carrierService: CarrierService) { }


  @ViewChild('CeqGrid', { static: false }) ceqGrid: CeqTableComponent;
  options: GridOptions;
  PageSizes = ["10", "25", "50", "100", "1000"];
  ceveList: Ceve[] = [];
  ceve: number = 0;
  keyword = "CeveName";
  selectedUnit: string;
  userLogin: UserLogin;
  type: string;

  gridOptions = {
    context: this,
    frameworkComponents: {
      childEditRenderer: EditChildRendered,
      childDeleteMessageRenderer: DeleteChildRendered
    },
    suppressHorizontalScroll: true,
    onRowDoubleClicked(event: any) { },
    icons: {
      sortAscending: '<i class="fa fa-sort-up" style="margin-left:10px"></i>',
      sortDescending: '<i class="fa fa-sort-down" style="margin-left:10px"></i>',
      sortUnSort: '<i class="fa fa-sort" style="margin-left:10px"></i>'
    }
  }

  columnDefs = [
    {
      headerName: 'Empleado',
      field: 'EmployeeCode',
      width: 20,
      cellClass: 'align-start',
      sortable: true,
      unSortIcon: true,
      resizable: true,
      editable: false
    },
    {
      headerName: 'Placa',
      field: 'LicensePlate',
      width: 20,
      cellClass: 'text-center',
      sortable: true,
      unSortIcon: true,
      resizable: true,
      editable: false
    },
    {
      headerName: 'Modelo',
      field: 'ModelYear',
      width: 10,
      cellClass: 'text-center',
      resizable: true,
      editable: false
    },
    {
      headerName: 'Configuración',
      field: 'VehicleConfiguration',
      width: 20,
      cellClass: 'text-center',
      resizable: true,
      editable: false
    },
    {
      headerName: 'Última modificación',
      field: 'ModifiedAt',
      width: 20,
      cellClass: 'text-center',
      editable: false,
      sortable: true,
      unSortIcon: true,
      resizable: true,
      cellRenderer: (params: any) => moment(params.data.ModifiedAt).format('YYYY-MM-DD HH:mm:ss')
    },
    {
      headerName: 'Modificado por',
      field: 'ModifiedBy',
      width: 20,
      cellClass: 'text-center',
      resizable: true,
      editable: false
    },
    {
      headerName: 'Editar',
      field: 'icon',
      width: 5,
      cellRenderer: 'childEditRenderer',
      colId: 'params',
      cellClass: 'text-center',
      hide: false,
    },
    {
      headerName: 'Eliminar',
      field: 'icon',
      width: 5,
      cellRenderer: 'childDeleteMessageRenderer',
      colId: 'params',
      cellClass: 'text-center',
      hide: false,
    }
  ];


  ngOnInit(): void {
    this.userLogin = this.settings.getUser();
    this.ceve = this.userLogin.UnitId;
  }

  gridEmiter(GridOptions: GridOptions) {
    this.options = GridOptions;
    this.getCeveList()
  }

  onPageSizeChange(value: number) {
    console.log(value);
  }

  btnAddClick() {
    window.open('/tax/carrier/create','_blank');
  }

  edit(row: any) {
    console.log("row", row.data);
    window.open('/tax/carrier/' + row.data.EmployeeCode,'_blank');
  }

  async delete(row: any) {
    const result = await this.globalFunctionService.messageBimbo("¿Desea eliminar el vehiculo del empleado " + row.data.EmployeeCode + "?", 'question1', 'Confirmacion');
      if (result) {
        this.carrierService.deleteCarrier(row.data.EmployeeCode).subscribe(async data => {
          console.log("result", data);
          await this.globalFunctionService.messageBimbo('El vehículo se eliminó correctamente.', 'success', '¡Éxito!');
		  
        }, async (error) => {
          console.log("error", error);
		      await this.globalFunctionService.messageBimbo( error.error, 'error', '¡Error!');
        }, () => {
          this.getCarriers();
        });
      }
  }


  getCeveList() {
    this.settings.getUserProfileLevels().then((userlevels) => {
      if (userlevels != undefined && userlevels.length > 0) {
        let findedLevel = userlevels.find(x => x.UnitId == this.userLogin.UnitId);
        if (findedLevel != undefined && findedLevel != null) {
          this.type = findedLevel.LevelType;
        }
        else {
          this.type = userlevels[0].LevelType;
        }
        this.ceveList = [];
        let userCeves = userlevels.filter(x => x.LevelType == "CEVE");
        if (userCeves.length > 0) {
          userCeves.forEach(unit => {
            let newCeve = new Ceve();
            newCeve.UnitId = unit.UnitId;
            newCeve.CeveName = unit.UnitDescription;
            this.ceveList.push(newCeve);
          });
          this.ceveList = this.ceveList.sort((a, b) => a.CeveName < b.CeveName ? -1 : 1);
          if (this.ceve == undefined) {
            this.ceve = this.ceveList[0].UnitId;
          }
          let userCeve = this.ceveList.find(x => x.UnitId == this.ceve);
          if (userCeve != undefined) {
            this.selectedUnit = userCeve.CeveName;
          }
        }
      }
      this.getCarriers();
    });
  }

  getCarriers() {
    this.ceqGrid.endPoint = `carrier/unit/${this.ceve}`
    this.ceqGrid.refreshTable();
  }

  selectEvent(event: any) {
    this.ceve = event.UnitId;
    this.getCarriers();
  }

  cmbOutputCeve(): void {

  }

}
